import React from 'react';
import {
  Dialog,
  Box,
  Avatar,
  Typography,
  CircularProgress,
} from '@mui/material';
import {
  Block as BlockIcon,
  LockOpen as UnlockIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import Button from '../../UIKit/Button';
import TextField from '../../UIKit/TextField';

const UserModals = ({
  showBanModal,
  selectedUser,
  banReason,
  userActionLoading,
  onClose,
  onToggleBan,
  onBanReasonChange,
}) => {
  const { t } = useTranslation(['admin', 'common', 'auth']);

  // Если нет выбранного пользователя, не рендерим модальное окно
  if (!selectedUser) {
    return null;
  }

  return (
    <>
      {/* Ban/Unban Dialog */}
      <Dialog
        open={showBanModal}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '16px',
            p: 2,
          },
        }}
      >
        <Box sx={{ textAlign: 'center', p: 3 }}>
          <Avatar
            sx={{
              bgcolor: !selectedUser?.isActive
                ? 'success.main'
                : 'warning.main',
              width: 64,
              height: 64,
              margin: '0 auto',
              mb: 2,
            }}
          >
            {!selectedUser?.isActive ? (
              <UnlockIcon sx={{ color: 'white', fontSize: 32 }} />
            ) : (
              <BlockIcon sx={{ color: 'white', fontSize: 32 }} />
            )}
          </Avatar>
          <Typography
            variant="h5"
            sx={{ mb: 1, fontSize: '1.25rem', fontWeight: 600 }}
          >
            {!selectedUser?.isActive
              ? t('admin:users.unban_title')
              : t('admin:users.ban_title')}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {!selectedUser?.isActive
              ? t('admin:users.unban_confirm', {
                  username: selectedUser?.fullName || 'User',
                })
              : t('admin:users.ban_confirm', {
                  username: selectedUser?.fullName || 'User',
                })}
          </Typography>

          {selectedUser?.isActive && (
            <TextField
              value={banReason}
              onChange={onBanReasonChange}
              multiline
              rows={3}
              fullWidth
              sx={{ mb: 3 }}
              placeholder={t('admin:users.ban_reason_placeholder')}
            />
          )}

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
            <Button
              onClick={onClose}
              variant="outlined"
              sx={{ minWidth: 100 }}
            >
              {t('common:actions.cancel')}
            </Button>
            <Button
              onClick={onToggleBan}
              variant="contained"
              color={!selectedUser?.isActive ? 'success' : 'warning'}
              disabled={userActionLoading}
              startIcon={
                userActionLoading ? <CircularProgress size={20} /> : null
              }
            >
              {userActionLoading
                ? t('common:actions.processing')
                : !selectedUser?.isActive
                ? t('admin:users.unban')
                : t('admin:users.ban')}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default UserModals; 